// extracted by mini-css-extract-plugin
module.exports = {"title":"VerificationLinkModal_title__1QOl2","emailFakeInput":"VerificationLinkModal_emailFakeInput__OOXIu"};